/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_TitleInputs */

const en_compare_event_groups_title = /** @type {(inputs: Compare_Event_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare Event Groups`)
};

const fr_compare_event_groups_title = /** @type {(inputs: Compare_Event_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer les groupes d'événements`)
};

const de_compare_event_groups_title = /** @type {(inputs: Compare_Event_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppen vergleichen`)
};

const it_compare_event_groups_title = /** @type {(inputs: Compare_Event_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta gruppi di eventi`)
};

const ru_compare_event_groups_title = /** @type {(inputs: Compare_Event_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнение групп событий`)
};

const es_compare_event_groups_title = /** @type {(inputs: Compare_Event_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar grupos de eventos`)
};

const zh_cn2_compare_event_groups_title = /** @type {(inputs: Compare_Event_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较事件组`)
};

const ja_compare_event_groups_title = /** @type {(inputs: Compare_Event_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループを比較する`)
};

const hi_compare_event_groups_title = /** @type {(inputs: Compare_Event_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूहों की तुलना करें`)
};

const pt_pt2_compare_event_groups_title = /** @type {(inputs: Compare_Event_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar grupos de eventos`)
};

/**
* | output |
* | --- |
* | "Compare Event Groups" |
*
* @param {Compare_Event_Groups_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_title = /** @type {((inputs?: Compare_Event_Groups_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_title(inputs)
	if (locale === "de") return de_compare_event_groups_title(inputs)
	if (locale === "it") return it_compare_event_groups_title(inputs)
	if (locale === "ru") return ru_compare_event_groups_title(inputs)
	if (locale === "es") return es_compare_event_groups_title(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_title(inputs)
	if (locale === "ja") return ja_compare_event_groups_title(inputs)
	if (locale === "hi") return hi_compare_event_groups_title(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_title(inputs)
	return en_compare_event_groups_title(inputs)
});